import { render, staticRenderFns } from "./EditorWidget.vue?vue&type=template&id=f79adc1e&scoped=true&"
import script from "./EditorWidget.vue?vue&type=script&lang=js&"
export * from "./EditorWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79adc1e",
  null
  
)

export default component.exports